import { Collapse, Progress, Tabs, Tooltip, Typography } from 'antd'
import styled from 'styled-components'
import { IconFont } from '@/components'
import { useEffect, useState } from 'react'
import * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react'
import SendEmail from '@/assets/imges/send-email.png'
import SubmitEmail from '@/assets/imges/submit-email.png'
import ClickEmail from '@/assets/imges/click-email.png'
import LookEmail from '@/assets/imges/look-email.png'
import { useGetTaskStd } from '../task-detail/utils'
import { t } from '@/i18n'
const { Panel } = Collapse
const { TabPane } = Tabs
export const TaskName = prop => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { id, type, score, start_time, name } = prop
  const [taskName, setTaskName] = useState(['2'])
  const [taskBasicsInfo, taskBasicsInfosInfo, taskBasicsInfoLoading] = useGetTaskStd({
    ids: id,
  })

  const option1 = (values: { value: number; title: string }) => {
    const { value, title } = values
    return {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 100,
          startAngle: 180,
          endAngle: 0,
          splitNumber: 5,
          radius: '100%',
          axisLine: {
            lineStyle: {
              width: 10,
              color: [
                [0.39, '#FF5151'],
                [0.59, '#FFB035'],
                [0.79, '#739DFF'],
                [1, '#7FB663'],
              ],
            },
          },
          pointer: {
            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
            length: '15%',
            width: 10,
            offsetCenter: [0, -45],
            itemStyle: {
              color: 'auto',
            },
          },
          axisTick: {
            length: 5,
            lineStyle: {
              color: 'auto',
              width: 1,
            },
            distance: 3,
          },
          splitLine: {
            length: 7,
            distance: 2,
            lineStyle: {
              color: 'auto',
              width: 2,
            },
          },
          axisLabel: {
            color: '#666666',
            fontSize: 8,
            distance: 15,
          },
          title: {
            offsetCenter: [0, -20],
            fontSize: 16,
          },
          detail: {
            fontSize: 20,
            offsetCenter: [0, 10],
            valueAnimation: true,
            formatter: function (num) {
              return `${Math.round(num)}`
            },
            color: 'auto',
          },
          data: [
            {
              value: value,
              name: title,
            },
          ],
        },
      ],
    }
  }

  const option2 = (values: { value: number }) => {
    const { value } = values
    return {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 100,
          startAngle: 180,
          endAngle: 0,
          splitNumber: 5,
          radius: '100%',
          // axisLine: {
          //   lineStyle: {
          //     width: 10,
          //     color: [[1, '#558492']],
          //   },
          // },
          progress: {
            show: true,
            width: 10,
          },
          itemStyle: {
            color: '#558492',
          },
          pointer: {
            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
            length: '15%',
            width: 10,
            offsetCenter: [0, -45],
            itemStyle: {
              color: '#558492',
            },
          },
          axisTick: {
            length: 5,
            lineStyle: {
              color: 'auto',
              width: 1,
            },
            distance: 3,
          },
          splitLine: {
            length: 7,
            distance: 2,
            lineStyle: {
              color: 'auto',
              width: 2,
            },
          },
          axisLabel: {
            color: '#666666',
            fontSize: 8,
            distance: 15,
          },
          title: {
            offsetCenter: [0, -20],
            fontSize: 16,
          },
          detail: {
            fontSize: 20,
            offsetCenter: [0, 10],
            valueAnimation: true,
            formatter: function (num) {
              return `${Math.round(num)}%`
            },
            color: 'auto',
          },
          data: [
            {
              value: value,
              name: t('中招率'),
            },
          ],
        },
      ],
    }
  }
  const [percent, setPercent] = useState(0)
  useEffect(() => {
    setPercent(50)
  }, [])

  useEffect(() => {
    if (id) {
      taskBasicsInfosInfo()
    }
  }, [id])

  const histogram = () => {
    if (type === '钓鱼链接') {
      return {
        grid: {
          top: '4%',
          left: '10px',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          name: '人',
          nameTextStyle: {
            align: 'left',
            fontWeight: 'bold',
            verticalAlign: 'top',
            lineHeight: 26,
            padding: [0, 0, 0, 5],
          },
          axisTick: {
            // X轴不要刻度线
            show: false,
          },
        },
        yAxis: {
          type: 'category',
          data: ['发送邮件', '查看邮件', '点击链接', '提交信息', '识破钓鱼'],
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: 'bar',
            radius: '100%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: '#87A2FF' },
                { offset: 1, color: 'rgba(120, 138, 205, 0.1)' },
              ]),
              borderRadius: [0, 8, 8, 0],
            },
            label: {
              show: true,
              position: 'left',
              offset: [40, 0],
              color: '#0A2CA4',
            },
            data: [
              taskBasicsInfo?.send_num || 0,
              taskBasicsInfo?.open_num || 0,
              taskBasicsInfo?.click_num || 0,
              taskBasicsInfo?.sub_num || 0,
              taskBasicsInfo?.see_through_num || 0,
            ],
          },
        ],
      }
    }
    if (type === '恶意附件') {
      return {
        grid: {
          top: '4%',
          left: '10px',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          name: '次',
          nameLocation: 'end',
          nameTextStyle: {
            fontWeight: 'bold',
            verticalAlign: 'top',
            lineHeight: 26,
          },
        },
        yAxis: {
          type: 'category',
          data: ['发送邮件', '查看邮件', '打开附件', '识破钓鱼'],
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: 'bar',
            radius: '100%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: '#87A2FF' },
                { offset: 1, color: 'rgba(120, 138, 205, 0.1)' },
              ]),
              borderRadius: [0, 8, 8, 0],
            },
            label: {
              show: true,
              position: 'left',
              offset: [40, 0],
              color: '#0A2CA4',
            },
            data: [
              taskBasicsInfo?.send_num || 0,
              taskBasicsInfo?.open_num || 0,
              taskBasicsInfo?.attach_num || 0,
              taskBasicsInfo?.see_through_num || 0,
            ],
          },
        ],
      }
    }
  }

  return (
    <TaskNameFold
      activeKey={taskName}
      ghost
      expandIconPosition={'end'}
      onChange={e => setTaskName(e)}
    >
      <Panel
        header={
          <>
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: 16,
                }}
              >
                <div style={{ fontWeight: 600 }}>
                  {t('最新任务：')}
                  <Typography.Text
                    ellipsis={{ tooltip: true }}
                    style={{ fontWeight: 600, maxWidth: 400 }}
                  >
                    {name}
                  </Typography.Text>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                  }}
                >
                  <span>{start_time}</span>
                  <IconFont
                    type="icon-zhankai1"
                    style={{
                      transform: `${taskName[0] === '2' ? 'none' : 'rotate(180deg)'}`,
                    }}
                  />
                </div>
              </div>
            </div>
            {taskName[0] !== '2' && (
              <div>
                <DetailDivContainer style={{ marginBottom: 10 }}>
                  <div className="div" style={{ background: '#f7f8f9' }}>
                    <div>{t('评分')}</div>
                    <div style={{ fontSize: 12 }}>
                      {(score <= 100 && score >= 80 && (
                        <span style={{ color: '#5bc825' }}>
                          {t('优秀/')}
                          {score}
                        </span>
                      )) ||
                        (score < 80 && score >= 60 && (
                          <span style={{ color: '#2973ff' }}>
                            {t('良好/')}
                            {score}
                          </span>
                        )) ||
                        (score < 60 && score >= 40 && (
                          <span style={{ color: '#ffa709' }}>
                            {t('较差/')}
                            {score}
                          </span>
                        )) ||
                        ((!score || score) < 40 && (
                          <span style={{ color: '#ff2929' }}>
                            {t('差/')}
                            {score ? score : 0}
                          </span>
                        ))}
                    </div>
                  </div>
                  <div className="div" style={{ background: '#f7f8f9' }}>
                    <div>{t('中招率')}</div>
                    <div style={{ fontSize: 12 }}>
                      <span>
                        {type === '钓鱼链接' ? (
                          <span>
                            {(
                              ((taskBasicsInfo?.click_num || 0) / (taskBasicsInfo?.send_num || 0) ||
                                0) * 100
                            ).toFixed(0)}
                          </span>
                        ) : (
                          <span>
                            {(
                              ((taskBasicsInfo?.attach_num || 0) /
                                (taskBasicsInfo?.send_num || 0) || 0) * 100
                            ).toFixed(0)}
                          </span>
                        )}
                        %
                      </span>
                    </div>
                  </div>
                </DetailDivContainer>
                <DetailDivContainer>
                  <div
                    className="div"
                    style={{
                      background: 'rgba(46,173,67,0.06)',
                    }}
                  >
                    <div>
                      <IconFont
                        type="icon-yunpanlogo_huabanfuben"
                        style={{ color: '#2CAB40', marginRight: 3 }}
                      />

                      <span>{t('发送邮件')}</span>
                    </div>
                    <div>
                      {(
                        ((taskBasicsInfo?.send_success_num || 0) /
                          (taskBasicsInfo?.create_num || 0) || 0) * 100
                      ).toFixed(0)}
                      %
                    </div>
                  </div>
                  <div className="div" style={{ background: 'rgba(0,117,255,0.06)' }}>
                    <div>
                      <IconFont
                        type="icon-yulantestsvg"
                        style={{ color: '#3279FF', marginRight: 3 }}
                      />

                      <span>{t('查看邮件')}</span>
                    </div>
                    <div>
                      {(
                        ((taskBasicsInfo?.open_num || 0) / (taskBasicsInfo?.create_num || 0) || 0) *
                        100
                      ).toFixed(0)}
                      %
                    </div>
                  </div>
                  <div className="div" style={{ background: 'rgba(255,186,0,0.06)' }}>
                    {type === '钓鱼链接' && (
                      <>
                        <div>
                          <IconFont
                            type="icon-icon-dianjifangkuang"
                            style={{ color: '#F6BE18', marginRight: 3 }}
                          />

                          <span>{t('点击链接')}</span>
                        </div>
                        <div>
                          {(
                            ((taskBasicsInfo?.click_num || 0) / (taskBasicsInfo?.create_num || 0) ||
                              0) * 100
                          ).toFixed(0)}
                          %
                        </div>
                      </>
                    )}
                    {type === '恶意附件' && (
                      <>
                        <div>
                          <IconFont
                            type="icon-icon-dianjifangkuang"
                            style={{ color: '#F6BE18', marginRight: 3 }}
                          />

                          <span>{t('打开附件')}</span>
                        </div>
                        <div>
                          {(
                            ((taskBasicsInfo?.attach_num || 0) /
                              (taskBasicsInfo?.create_num || 0) || 0) * 100
                          ).toFixed(0)}
                          %
                        </div>
                      </>
                    )}
                  </div>
                  {type === '钓鱼链接' && (
                    <div className="div" style={{ background: ' rgba(165,160,255,0.06)' }}>
                      <div>
                        <IconFont
                          type="icon-yanzhengma"
                          style={{ color: '#7C74FF', marginRight: 3 }}
                        />

                        <span>{t('提交信息')}</span>
                      </div>
                      <div>
                        {(
                          ((taskBasicsInfo?.sub_num || 0) / (taskBasicsInfo?.create_num || 0) ||
                            0) * 100
                        ).toFixed(0)}
                        %
                      </div>
                    </div>
                  )}
                  <div className="div" style={{ background: ' rgba(118,134,162,0.06)' }}>
                    <div>
                      <IconFont
                        type="icon-yanzhengma"
                        style={{ color: '#7686A2', marginRight: 3 }}
                      />

                      <span>{t('识破钓鱼')}</span>
                    </div>
                    <div>
                      {(
                        ((taskBasicsInfo?.see_through_num || 0) /
                          (taskBasicsInfo?.create_num || 0) || 0) * 100
                      ).toFixed(0)}
                      %
                    </div>
                  </div>
                </DetailDivContainer>
              </div>
            )}
          </>
        }
        key={2}
        showArrow={false}
      >
        <TaskNameMain>
          <div className="score">
            <div className="instrument">
              <p className="task-title">{t('评分')}</p>

              <div style={{ display: 'flex' }}>
                <ReactECharts
                  style={{
                    width: 220,
                    height: 190,
                    marginBottom: -14,
                  }}
                  option={option1({
                    value: score || 0,
                    title: score
                      ? (score <= 100 && score >= 80 && t('优秀')) ||
                        (score < 80 && score >= 60 && t('良好')) ||
                        (score < 60 && score >= 40 && t('较差')) ||
                        (score < 40 && t('差'))
                      : t('差'),
                  })}
                />
              </div>
            </div>
            <div className="instrument">
              <p className="task-title" style={{ marginLeft: 0 }}>
                <div>
                  <span style={{ marginRight: 4 }}>{t('中招率')}</span>
                  <Tooltip
                    title={
                      type === '钓鱼链接'
                        ? t('中招率：点击链接人数/任务评估总人数')
                        : t('中招率：打开附件人数/任务评估总人数')
                    }
                  >
                    <IconFont type="icon-tishi" style={{ color: '#999' }} />
                  </Tooltip>
                </div>
              </p>
              <div style={{ display: 'flex' }}>
                <div style={{ height: 116, width: 1, background: '#DFDFDF', marginTop: 10 }} />
                <ReactECharts
                  style={{
                    width: 220,
                    height: 190,
                    marginBottom: -14,
                    marginLeft: 15,
                  }}
                  option={option2({
                    value:
                      type === '钓鱼链接'
                        ? Number(
                            (
                              ((taskBasicsInfo.click_num || 0) / (taskBasicsInfo?.send_num || 0) ||
                                0) * 100
                            ).toFixed(0),
                          )
                        : Number(
                            (
                              ((taskBasicsInfo?.attach_num || 0) /
                                (taskBasicsInfo?.send_num || 0) || 0) * 100
                            ).toFixed(0),
                          ),
                  })}
                />
              </div>
            </div>
            <div style={{ width: 'calc(100% - 500px)' }}>
              <Tabs
                defaultActiveKey="1"
                tabPosition={'top'}
                style={{ height: 184, overflow: 'hidden' }}
                getPopupContainer={(node: any) => node?.parentNode.parentNode}
              >
                <TabPane
                  key={1}
                  tab={
                    <div className="instrument">
                      <div className="task-title">
                        <div>
                          <IconFont
                            type="icon-yunpanlogo_huabanfuben"
                            style={{ color: '#2CAB40', marginRight: 3 }}
                          />

                          <span>{t('发送邮件')}</span>
                        </div>
                        <div className="score-text">
                          {taskBasicsInfo?.send_success_num || 0} /{' '}
                          {taskBasicsInfo?.create_num || 0}
                        </div>
                      </div>
                      <div className="chart">
                        <div>
                          {(
                            ((taskBasicsInfo?.send_success_num || 0) /
                              (taskBasicsInfo?.create_num || 0) || 0) * 100
                          ).toFixed(0)}
                          %
                        </div>
                        <img src={SendEmail} alt="" className="image" />
                      </div>
                    </div>
                  }
                />

                <TabPane
                  key={2}
                  tab={
                    <div className="instrument">
                      <div className="task-title">
                        <div>
                          <IconFont
                            type="icon-yulantestsvg"
                            style={{ color: '#3279FF', marginRight: 3 }}
                          />

                          <span>{t('查看邮件')}</span>
                        </div>
                        <div className="score-text">
                          {taskBasicsInfo?.open_num | 0}/{taskBasicsInfo?.create_num || 0}
                        </div>
                      </div>
                      <div className="chart">
                        <div>
                          {(
                            ((taskBasicsInfo?.open_num || 0) / (taskBasicsInfo?.create_num || 0) ||
                              0) * 100
                          ).toFixed(0)}
                          %
                        </div>
                        <img src={LookEmail} alt="" className="image" />
                      </div>
                    </div>
                  }
                />

                <TabPane
                  key={3}
                  tab={
                    type === '钓鱼链接' && (
                      <div className="instrument">
                        <div className="task-title">
                          <div>
                            <IconFont
                              type="icon-icon-dianjifangkuang"
                              style={{ color: '#F6BE18', marginRight: 3 }}
                            />

                            <span>{t('点击链接')}</span>
                          </div>
                          <div className="score-text">
                            {taskBasicsInfo?.click_num | 0}/{taskBasicsInfo?.create_num || 0}
                          </div>
                        </div>
                        <div className="chart">
                          <div>
                            {(
                              ((taskBasicsInfo?.click_num || 0) /
                                (taskBasicsInfo?.create_num || 0) || 0) * 100
                            ).toFixed(0)}
                            %
                          </div>
                          <img src={ClickEmail} alt="" className="image" />
                        </div>
                      </div>
                    )
                  }
                />

                <TabPane
                  key={4}
                  tab={
                    type === '恶意附件' && (
                      <div className="instrument">
                        <div className="task-title">
                          <div>
                            <IconFont
                              type="icon-icon-dianjifangkuang"
                              style={{ color: '#F6BE18', marginRight: 3 }}
                            />

                            <span>{t('打开附件')}</span>
                          </div>
                          <div className="score-text">
                            {taskBasicsInfo?.attach_num | 0}/{taskBasicsInfo?.create_num || 0}
                          </div>
                        </div>
                        <div className="chart">
                          <div>
                            {(
                              ((taskBasicsInfo?.attach_num || 0) /
                                (taskBasicsInfo?.create_num || 0) || 0) * 100
                            ).toFixed(0)}
                            %
                          </div>
                          <img src={ClickEmail} alt="" className="image" />
                        </div>
                      </div>
                    )
                  }
                />

                <TabPane
                  key={5}
                  tab={
                    type === '钓鱼链接' && (
                      <div className="instrument">
                        <div className="task-title">
                          <div>
                            <IconFont
                              type="icon-tijiao"
                              style={{ color: '#7C74FF', marginRight: 3 }}
                            />

                            <span>{t('提交信息')}</span>
                          </div>
                          <div className="score-text">
                            {taskBasicsInfo?.sub_num | 0}/{taskBasicsInfo?.create_num || 0}
                          </div>
                        </div>
                        <div className="chart">
                          <div>
                            {(
                              ((taskBasicsInfo?.sub_num || 0) / (taskBasicsInfo?.create_num || 0) ||
                                0) * 100
                            ).toFixed(0)}
                            %
                          </div>
                          <img src={SubmitEmail} alt="" className="image" />
                        </div>
                      </div>
                    )
                  }
                />

                <TabPane
                  key={6}
                  tab={
                    <div className="instrument">
                      <div className="task-title">
                        <div>
                          <IconFont
                            type="icon-yanzhengma"
                            style={{ color: '#7C74FF', marginRight: 3 }}
                          />

                          <span>{t('识破钓鱼')}</span>
                        </div>
                        <div className="score-text">
                          {taskBasicsInfo?.see_through_num | 0}/{taskBasicsInfo?.create_num || 0}
                        </div>
                      </div>
                      <div className="chart">
                        <div>
                          {(
                            ((taskBasicsInfo?.see_through_num || 0) /
                              (taskBasicsInfo?.create_num || 0) || 0) * 100
                          ).toFixed(0)}
                          %
                        </div>
                        <img src={SubmitEmail} alt="" className="image" />
                      </div>
                    </div>
                  }
                />
              </Tabs>
            </div>
          </div>
          {/* <div>
             <div style={{ marginTop: 16, marginBottom: 32 }}>
               中招率
               <span>
                 {type === '钓鱼链接' ? (
                   <span>
                     {(
                       ((taskBasicsInfo?.click_num || 0) / (taskBasicsInfo?.send_num || 0) || 0) *
                       100
                     ).toFixed(0)}
                   </span>
                 ) : (
                   <span>
                     {(
                       ((taskBasicsInfo?.attach_num || 0) / (taskBasicsInfo?.send_num || 0) || 0) *
                       100
                     ).toFixed(0)}
                   </span>
                 )}
                 %
               </span>
               <Tooltip
                 placement="top"
                 title={
                   type === '钓鱼链接'
                     ? '中招率：点击链接人数/任务评估总人数'
                     : '中招率：打开附件人数/任务评估总人数'
                 }
               >
                 <IconFont type="icon-tishi" style={{ marginLeft: 5, color: '#8e8e90' }} />
               </Tooltip>
             </div>
            </div> */}
          <div style={{ marginTop: 32 }}>
            <div className="dongzuo">{t('响应动作')}</div>
            <ReactECharts option={histogram()} style={{ height: '260px' }} />
          </div>
        </TaskNameMain>
      </Panel>
    </TaskNameFold>
  )
}

const TaskNameFold = styled(Collapse)`
  background: #fff !important;
  .ant-collapse-header {
    width: 100%;
    padding-right: 20px !important;
    padding-bottom: 0px !important;
  }
  .ant-collapse-header-text {
    width: 100%;
  }
  .ant-collapse-content-box {
    padding-top: 0 !important;
  }
`
const TaskNameMain = styled.div`
  .dongzuo {
    width: 48px;
    font-size: 12px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #666666;
  }
  .score {
    height: 184px;
    width: 100%;
    display: flex;
    background: #f8f9fb;
    border-radius: 9px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #333;
    text-shadow: unset;
  }
  .ant-tabs-ink-bar {
    background: transparent;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
    padding: 0;
  }
  .instrument {
    flex: 1;
    padding: 17px 12px 17px 0;
    height: 160px;
    width: 332px;
    min-height: 140px;
    overflow: hidden;
  }
  .task-title {
    font-size: 14px;
    color: #666;
    display: flex;
    justify-content: space-between;
    margin-left: 16px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .chart {
    height: 100px;
    display: flex;
    align-items: flex-end;
    border-left: 1px solid #dfdfdf;
    padding: 0 0 0 25px;
    font-size: 24px;
    font-weight: 600;
    margin-top: 10px;
    justify-content: space-between;
  }
  .score-text {
    font-size: 16px;
  }
  .image {
    width: 60%;
    margin-bottom: -16px;
  }
`
const DetailDivContainer = styled.div`
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  width: 100%;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, minmax(164px, 1fr));
  grid-gap: 10px;
  .div {
    display: flex;
    justify-content: space-between;
    padding: 16px 12px;
    align-items: center;
    height: 48px;
    border-radius: 6px;
  }
`
